// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#block1 .top-title[data-v-64ada120]{margin-top:calc(var(--fs-600)*2);font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
